import React, { useCallback } from 'react'
import { Header } from '../../../Desktop/ProjectListing/Sidebar/Header'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import projectsStore from '../../../Store'
import { TouchableOpacity, View } from 'react-native'
import { BtText, BtSidebar } from '@linqpal/components/src/ui'
import { EInvoiceAddressType, routes } from '@linqpal/models'
import { fileDownloader } from '@linqpal/common-frontend/src/helpers'
import { styles } from './styles'
import { FilePdfIcon, ArrowRightLines } from '../../../../../assets/icons'
import { ui } from '@linqpal/components'
import {
  currencyMask,
  phoneMaskWithoutCode,
} from '../../../../../utils/helpers/masking'
import moment from 'moment'

const { BtStatus } = ui

export const ViewInvoiceSidebar = observer(() => {
  const { viewInvoice, setViewInvoice, activeInvoice } = projectsStore
  const { t } = useTranslation('global')

  const handleDownload = useCallback(() => {
    if (activeInvoice.invoice_document) {
      routes.file.download(activeInvoice.invoice_document).then(({ url }) => {
        fileDownloader(url)
      })
    }
  }, [activeInvoice?.invoice_document])

  const closeSidebar = () => {
    setViewInvoice(false)
  }

  return (
    <BtSidebar
      visible={viewInvoice}
      onClose={() => {
        closeSidebar()
        return null
      }}
      width={584}
      title={
        <Header
          closeSidebar={closeSidebar}
          title={t('Projects.paymentDetails')}
        />
      }
      customPadding={32}
    >
      <View style={{ paddingHorizontal: 20 }}>
        <BtText style={styles.title}>{t('Projects.invoiceDetails')}</BtText>
        {activeInvoice?.document_name && (
          <TouchableOpacity style={styles.fileWrapper} activeOpacity={0.7}>
            <FilePdfIcon width={15} height={20} />
            <BtText
              testID="projects_view_invoice_document_name"
              style={styles.fileName}
              onClick={(e) => {
                e.preventDefault()
                handleDownload()
              }}
            >
              {activeInvoice?.document_name}
            </BtText>
            <ArrowRightLines width={16} height={16} />
          </TouchableOpacity>
        )}
        <View style={styles.item}>
          <BtText style={styles.itemLabel}>
            {t('Projects.invoiceNumber')}
          </BtText>
          <BtText
            style={styles.itemValue}
            testID="projects_view_invoice_invoice_number"
          >
            {activeInvoice?.invoice_number}
          </BtText>
        </View>
        <View style={styles.item}>
          <BtText style={styles.itemLabel}>{t('Projects.businessName')}</BtText>
          <BtText
            style={styles.itemValue}
            testID="projects_view_invoice_business_name"
          >
            {activeInvoice?.business_name}
          </BtText>
        </View>
        {activeInvoice?.business_phone && (
          <View style={styles.item}>
            <BtText style={styles.itemLabel}>
              {t('Projects.phoneNumber')}
            </BtText>
            <BtText
              style={styles.itemValue}
              testID="projects_view_invoice_phone"
            >
              {phoneMaskWithoutCode(activeInvoice?.business_phone)}
            </BtText>
          </View>
        )}
        {activeInvoice?.addressType !== EInvoiceAddressType.DELIVERY ? (
          <View style={styles.item}>
            <BtText style={styles.itemLabel}>
              {t('Projects.deliverType')}
            </BtText>
            <BtText
              style={styles.itemValue}
              testID="projects_view_invoice_address"
            >
              {activeInvoice?.addressType}
            </BtText>
          </View>
        ) : (
          <View style={styles.item}>
            <BtText style={styles.itemLabel}>{t('Projects.deliverTo')}</BtText>
            <BtText
              style={styles.itemValue}
              testID="projects_view_invoice_address"
            >
              {activeInvoice?.address}
            </BtText>
          </View>
        )}
        {activeInvoice?.status === 'PAID' ||
        activeInvoice?.status === 'PAYMENTPROCESSING' ? (
          <View style={styles.item}>
            <BtText style={styles.itemLabel}>{t('Projects.paidOn')}</BtText>
            <BtText
              style={styles.itemValue}
              testID="projects_view_invoice_address"
            >
              {moment(activeInvoice?.operation?.date).format('MM/DD/YYYY')}
            </BtText>
          </View>
        ) : null}
        <View style={styles.item}>
          <BtText style={styles.itemLabel}>{t('Projects.status')}</BtText>
          <BtStatus
            type={activeInvoice?.status}
            testID="projects_view_invoice_invoice_status"
          />
        </View>
        <View style={styles.amountContainer}>
          <BtText style={styles.amountLabel}>
            {t('Projects.totalAmount')}
          </BtText>
          <BtText
            style={styles.amountValue}
            testID="projects_view_invoice_total_amount"
          >
            {currencyMask(activeInvoice?.total_amount)}
          </BtText>
        </View>
      </View>
    </BtSidebar>
  )
})
